import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppService} from '../../../../app.service';
import {BonusService} from '../../bonus.service';
import {Constants} from '../../../../shared/utils/constants';
import {NgForm} from '@angular/forms';
import {BonusManualModel} from '../../../../models/bonus-manual.model';
import {getAccountNameByType} from "../../../../shared/utils/helper";

declare var $: any;

@Component({
  selector: 'fx-bonus-history',
  templateUrl: './bonus-history.component.html',
  styleUrls: ['./bonus-history.component.sass']
})
export class BonusHistoryComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('form') form: NgForm;
  loading = false;
  addChangeMode = false;
  valueAmount = null;
  data = [];
  condition: any = {
    q: '',
  };
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  itemBonusManual = new BonusManualModel();
  currency = '¥';
  itemBonus: any = {};
  isAddChange = false;
  submited = false;
  currentIndex = null;
  historyMT4Info: any = {};
  constructor(
    private bonusService: BonusService,
    private appService: AppService
  ) { }

  ngOnInit(): void {
    this.searchHistory();
  }

  searchHistory(search?: boolean): void {
    this.pageInfo.pageIndex = 1;
    this.loading = search;
    const params = {
      q: (this.condition.keyword)
        ? encodeURIComponent((this.condition.keyword).trim())
        : this.condition.keyword,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.getHistory(params);
  }
  getHistory(params: any): void {
    this.bonusService.getBonusManualHistory(params)
      .subscribe(res => {
        this.loading = false;
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.data = res.data;
          this.pageInfo.totalRecord = res.paging.total;
        }
      });
  }
  onRefresh(refresh?: boolean): void {
    this.condition.keyword = '';
    this.searchHistory(refresh);
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    const params = {
      q: this.condition.keyword,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
    };
    this.getHistory(params);
  }

  getAccountType(groupName): string {
    if(groupName.includes("STD")){
      return 'Standard';
    }
    if(groupName.includes("MIC")){
      return 'Micro';
    }
    if(groupName.includes("PRO")){
      return 'Pro';
    }
    return 'Standard'
  }

  getBonusInfo(item): void {
    const newItem = JSON.parse(JSON.stringify(item));
    const listData = newItem.data.map(v => {
      v.amount = 0;
      v.accountType = v.type;
      v.accountType = getAccountNameByType(v)
      return v;
    });
    this.itemBonus = {
      name: newItem.email,
      data: listData
    };
  }
  onChangeAmount(event, item): void {
    this.isAddChange = (event === 'add');
    this.submited = true;
    this.currentIndex = item.login;
    if (item.amount <= 0) {
      return;
    }
    const body = {
      login: item.login,
      volume: (this.isAddChange) ? +item.amount  : -item.amount
    };
    this.appService .confirm({
      title: `Are you sure that you want to ${
        (this.isAddChange) ? 'deposit' : 'withdraw'
        } amount?`,
      icon: 'fa fa-question-circle',
      ok: 'Ok',
      cancel: 'Cancel',
    })
      .subscribe((res) => {
        if (res.result) {
          this.onSubmitAmount(body);
        }
      });
  }
  onSubmitAmount(body): void {
    this.submited = false;
    this.currentIndex = null;
    this.bonusService.updateBonusManualAmount(body)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.appService.showSuccess(((this.isAddChange) ? 'Add' : 'Reduce')  + ' amount manual control success.');
          this.updateCredit(body, this.isAddChange);
          // $('#modalManualChangeAmount .close').trigger('click');
        } else {
          this.appService.showError(res.error_code);
        }
      });
  }
  private updateCredit(data, type): void {
    this.itemBonus.data = this.itemBonus.data.map(v => {
      if (v.login === data.login) {
        v.credit = (type) ? (v.credit + data.volume) : (v.credit - Math.abs(data.volume));
        v.amount = 0;
      }
      return v;
    });
  }
  getHisMT4Info(item): void {
    $('#modalBonusChangeAmount').css('display', 'none');
    this.historyMT4Info = {
      login: item.login,
      currency: item.currency
    };
    const option = {
      login: item.login
    };
    this.bonusService.getHistoryMT4Transactions(option)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          this.historyMT4Info.data = res.data;
        }
      });
  }
  ngAfterViewInit(): void {
    $('#modalBonusChangeAmount').on('hide.bs.modal', () => {
      localStorage.setItem('un_loading', 'true');
      const params = {
        q: this.condition.keyword,
        page: this.pageInfo.pageIndex,
        page_size: this.pageInfo.pageSize,
      };
      this.getHistory(params);
    });
    $('#modalHistoryAccountMT').on('hide.bs.modal', () => {
      $('#modalBonusChangeAmount').hide();
    });
  }
  ngOnDestroy(): void {
    this.itemBonusManual = new BonusManualModel();
  }

}
